/* 中文（简体）— Chinese Simplified */
const zh = {
  nav: {
    home: '首页',
    imageConverter: '图片转换',
    imageCompressor: '图片压缩',
    otherTools: '更多工具',
    resizeImage: '调整图片尺寸',
    cropImage: '图片裁剪',
    photoEditor: '照片编辑器',
    removeBackground: '背景去除',
    watermarkImage: '添加水印',
    qrCodeGenerator: '二维码生成器',
    qrCodeScanner: '二维码扫描器',
    aboutUs: '关于我们',
    faceBlur: '人脸模糊',
  },
  hero: {
    heading: '您所需的所有图片工具',
    subheading: '免费在线转换、压缩、调整、裁剪和编辑图片。一切在浏览器中处理——快速、私密、安全。',
  },
  tools: {
    compressImage: { title: '压缩图片', desc: '压缩 JPG、PNG、SVG 和 GIF，节省空间同时保持质量。' },
    resizeImage: { title: '调整图片尺寸', desc: '按百分比或像素调整 JPG、PNG、SVG 和 GIF 图片大小。' },
    cropImage: { title: '裁剪图片', desc: '轻松裁剪 JPG、PNG 或 GIF。用像素定义矩形或使用可视编辑器。' },
    convertToJpg: { title: '转换为 JPG', desc: '将 PNG、GIF、TIF、PSD、SVG、WEBP、HEIC 或 RAW 格式的图片批量转换为 JPG。' },
    convertFromJpg: { title: '从 JPG 转换', desc: '将 JPG 图片转换为 PNG 或 GIF。选择多张 JPG 合成动态 GIF！' },
    qrCodeGenerator: { title: '二维码生成器', desc: '为 URL、文本、WiFi、联系人、邮件、地图生成自定义二维码。自定义样式、颜色和 Logo。' },
    qrCodeScanner: { title: '二维码扫描器', desc: '通过摄像头或图片上传即时扫描二维码，检测 URL、文本、WiFi、联系人等。' },
    blurFace: { title: '人脸模糊', desc: '自动检测并模糊图片中的人脸以保护隐私。可调整模糊强度、形状和表情符号覆盖。' },
    removeBackground: { title: '背景去除', desc: '高精度快速去除图片背景。即时检测对象并抠出背景。' },
    watermarkImage: { title: '添加水印', desc: '几秒内为图片添加文字或图片水印。可选择字体、透明度和位置。' },
  },
  whyChoose: {
    label: '选择我们的理由',
    heading: '更智能的图片编辑方式',
    subheading: '全球数千名创作者、设计师和开发者的信赖之选。以下是 photremium.com 成为图片编辑首选的原因。',
    reasons: {
      fast: { title: '超快处理', desc: '一切处理直接在您的浏览器中完成。无需上传到外部服务器——结果在毫秒内呈现。' },
      private: { title: '100% 私密安全', desc: '您的文件永远不会离开您的设备。我们从不存储、共享或访问您的图片。完全隐私保证。' },
      noLimits: { title: '无限制，无需注册', desc: '所有工具随意使用——完全免费。无需账户，无水印，无隐藏费用。' },
      quality: { title: '专业品质', desc: '我们的算法提供工作室级别的效果。无损压缩，完美保真转换。' },
      batch: { title: '批量处理', desc: '一次处理多个文件。一键转换、压缩或调整整个图片文件夹。' },
      everywhere: { title: '随处可用', desc: '完全响应式设计，在桌面、平板和手机上均可完美运行。无需下载或安装。' },
    },
    stats: {
      imagesProcessed: '已处理图片',
      countriesServed: '服务国家',
      uptime: '正常运行时间',
      freeTools: '免费工具',
    },
  },
  footer: {
    tagline: '免费在线图片工具——几秒内转换、压缩、调整、裁剪和编辑图片。无需注册。',
    imageTools: '图片工具',
    moreTools: '更多工具',
    company: '公司信息',
    contact: '联系我们',
    allRightsReserved: '版权所有。',
    privacyPolicy: '隐私政策',
    termsOfService: '服务条款',
  },
  faq: {
    badge: '常见问题',
    heading: '常见问题',
    subheading: '关于本工具的常见问题解答。',
    stillHaveQuestions: '还有其他问题？随时联系我们！',
    reachOut: '联系我们的团队',
    questionHeader: '问题',
  },

  contactForm: {
    badge: '联系我们',
    title: '联系我们',
    subtitle: '我们很乐意听到您的声音，请给我们发一条消息！',
    nameLabel: '姓名',
    namePlaceholder: '您的全名',
    emailLabel: '电子邮件',
    emailPlaceholder: 'you@example.com',
    subjectLabel: '主题',
    subjectPlaceholder: '这是关于什么的？',
    messageLabel: '消息',
    messagePlaceholder: '在此写下您的消息…',
    errName: '姓名为必填项',
    errEmail: '电子邮件为必填项',
    errEmailInvalid: '请输入有效的电子邮件',
    errSubject: '主题为必填项',
    errMessage: '消息为必填项',
    sending: '发送中…',
    send: '发送消息',
    successTitle: '消息已发送!',
    successMsg: '感谢您的联系，我们将尽快回复您。',
    sendAnother: '再发一条',
    sendError: '出错了，请重试。',
  },

  about: {
    label: '关于我们',
    heading: '由创作者为创作者打造',
    subheading: '我们相信强大的图片工具应该是免费的、快速的，人人都能使用的。',
    missionTitle: '我们的使命',
    missionText: 'photremium.com 的构建目标简单明确：提供网络上最直观、最快速、最私密的图片编辑体验。由于一切在浏览器中处理，您的文件永远不会离开您的设备。无需账户、无限制、无妥协。',
    privacyTitle: '隐私优先',
    privacyText: '我们从不在远程服务器上上传、存储或处理图片。一切都保留在您的设备上。',
    techTitle: '前沿技术',
    techText: '使用 WebAssembly、Canvas API、最新 React 等尖端网络技术构建。',
    communityTitle: '社区驱动',
    communityText: '我们构建的每一个功能都基于真实用户反馈。您的建议塑造我们的路线图。',
    globalTitle: '全球覆盖',
    globalText: '被 120 多个国家的创作者使用。通过超快 CDN 交付，支持多语言。',
  },
  seo: {
    homeTitle: 'photremium.com — 免费在线图片转换、压缩和编辑工具',
    homeDesc: '免费在线转换、压缩、调整、裁剪和编辑图片。快速、私密、安全——一切在浏览器中处理。',
    homeKeywords: '图片转换, 图片压缩, 调整尺寸, 裁剪, 照片编辑器, 免费图片工具',
    aboutTitle: '关于 photremium.com — 我们的使命与故事',
    aboutDesc: '了解 photremium.com——数百万人信赖的免费在线图片工具集。',
    aboutKeywords: '关于 photremium.com, 图片工具, 免费图片编辑器',
  },
        privacyPolicyPage: {
    seo: {
      title: '隐私政策 — Photremium |无服务器上传，零数据存储',
      description: 'Photremium 的隐私政策解释了我们如何保护您的隐私。所有图像处理 100% 在您的浏览器中进行 — 不会将文件上传到任何服务器，不会收集个人数据，也不会进行跟踪。',
      ogTitle: '隐私政策 — Photremium |无需上传，零存储',
      ogDescription: '您的文件保留在您的设备上。 Photremium 在您的浏览器中本地处理所有图像，无需与服务器联系，不存储数据，也不进行跟踪。',
      twitterTitle: '隐私政策 — Photremium',
      twitterDescription: '100% 基于浏览器的图像工具。没有上传，没有存储，没有跟踪。请阅读我们完整的隐私政策。',
      schemaName: '隐私政策 - Photremium',
      schemaDescription: 'Photremium 隐私政策 - 无服务器上传、无数据存储、100% 浏览器内图像处理。'
    },
    hero: {
      badge: '隐私政策',
      titlePrefix: '您的隐私就是我们的',
      titleHighlight: '最优先',
      subPrefix: 'photremium.com 的建立基于一个简单的原则 —',
      subStrong: '您的文件永远不会离开您的设备',
      subSuffix: '该网站上的每个图像工具都完全在您的浏览器内运行。没有上传。没有云。没有妥协。',
      effectiveLabel: '有效的',
      lastUpdatedLabel: '最后更新',
      worldwideLabel: '适用于全球'
    },
    trustCards: [
      {
        title: '无服务器上传',
        desc: '您的文件永远不会离开您的设备。所有处理都是 100% 在浏览器内进行。'
      },
      {
        title: '零数据存储',
        desc: '我们不会存储任何有关您、您的图像或您的活动的信息。'
      },
      {
        title: '无追踪',
        desc: '没有行为跟踪，没有指纹识别，没有分析。'
      },
      {
        title: 'GDPR 友好',
        desc: '从头开始设计就尊重全球隐私法规。'
      }
    ],
    contentsTitle: '内容',
    toc: {
      overview: '概述',
      'no-upload': '无服务器处理',
      'data-collect': '我们收集的数据',
      cookies: 'Cookie 和存储',
      'third-party': '第三方服务',
      analytics: '分析',
      children: '儿童隐私',
      rights: '您的权利',
      security: '安全',
      changes: '政策变化',
      contact: '联系我们'
    },
    sections: {
      overview: {
        title: '1. 概述',
        subtitle: '该政策涵盖哪些内容',
        p1Prefix: '本隐私政策描述了如何',
        p1Middle: '（“我们”、“我们”或“我们的”）处理 - 或者更准确地说，',
        p1Italic: '不处理',
        p1Suffix: '当您使用我们的免费在线图像工具时您的个人信息',
        p2: '与将文件发送到远程服务器进行处理的传统 Web 应用程序不同，photremium.com 使用现代浏览器 API（Canvas API、WebAssembly、WebWorkers）在您的设备上本地执行每个操作。结果：没有数据传输、没有存储、没有风险。',
        calloutLabel: '简单的英文总结：',
        calloutText: '我们看不到您的图像，我们也不想看到，而且我们的技术经过专门设计，因此我们永远看不到。'
      },
      noUpload: {
        title: '2. 永远没有服务器处理',
        subtitle: '我们的工具实际上是如何工作的',
        introPrefix: 'photremium.com 上的每个工具（图像转换器、压缩器、缩放器、背景去除器、面部模糊、水印、裁剪和二维码工具）都会处理您的文件',
        introStrong: '100% 在您的网络浏览器中',
        introSuffix: '使用客户端 JavaScript 和 WebAssembly。',
        points: [
          {
            label: '不会发生任何文件上传。',
            text: '当您选择一个文件时，浏览器的文件 API 会读取该文件并在内存中进行处理 - 它永远不会通过网络发送。'
          },
          {
            label: '没有服务器接收您的图像。',
            text: '我们的 CDN 仅提供运行应用程序所需的 HTML、CSS 和 JavaScript 资源，而不是您的文件。'
          },
          {
            label: '没有临时存储。',
            text: '处理后的结果仅存在于您的浏览器内存中，并在您关闭或离开页面时释放。'
          },
          {
            label: '离线工作。',
            text: '大多数工具在初始页面加载后无需互联网连接即可继续运行 - 进一步证明不涉及服务器。'
          }
        ],
        callout: '您可以自己验证这一点：在开发者工具中打开浏览器的“网络”选项卡，选择一个图像，并确认没有文件数据传输到任何外部服务器。'
      },
      dataCollect: {
        title: '3. 我们收集（和不收集）的数据',
        subtitle: '数据实践完全透明',
        headers: {
          type: '数据类型',
          collected: '集？',
          whereWhy: '地点/原因'
        },
        rows: [
          {
            type: '您的图像/文件',
            badge: '绝不',
            variant: '绿色的',
            showX: true,
            whereWhy: '完全在您的浏览器中处理 - 从未传输'
          },
          {
            type: '姓名/电子邮件地址',
            badge: '绝不',
            variant: '绿色的',
            showX: true,
            whereWhy: '使用任何工具无需帐户或注册'
          },
          {
            type: 'IP地址',
            badge: '最小',
            variant: '灰色的',
            showX: false,
            whereWhy: '标准 Web 服务器日志保留 <= 30 天，与身份无关'
          },
          {
            type: '浏览器/操作系统类型',
            badge: '最小',
            variant: '灰色的',
            showX: false,
            whereWhy: '由您的浏览器自动发送；仅用于兼容性'
          },
          {
            type: '访问页面/点击次数',
            badge: '聚合',
            variant: '蓝色的',
            showX: false,
            whereWhy: '仅匿名分析（无个人身份识别）'
          },
          {
            type: '语言偏好',
            badge: '仅限本地',
            variant: '蓝色的',
            showX: false,
            whereWhy: '保存到您设备上的 localStorage — 从未发送给我们'
          },
          {
            type: '付款/财务数据',
            badge: '绝不',
            variant: '绿色的',
            showX: true,
            whereWhy: 'photremium.com 完全免费，无需付款'
          }
        ]
      },
      cookies: {
        title: '4. Cookie 和本地存储',
        subtitle: '您的设备上存储的内容',
        intro: 'photremium.com 不使用广告 cookie、跨站点跟踪 cookie 和第三方 cookie。我们使用的唯一浏览器存储用于基本的网站功能。',
        points: [
          {
            label: '语言偏好',
            text: '存储在 localStorage 中，以便网站在访问之间记住您的首选语言。从未发送到我们的服务器。'
          },
          {
            label: '主题/用户界面首选项',
            text: '如果您设置显示首选项，它只会保存在您的设备本地。'
          },
          {
            label: '没有会话 cookie。',
            text: 'photremium.com 没有登录系统，因此不会写入会话 ID cookie。'
          }
        ],
        callout: '您可以随时通过浏览器设置（设置 -> 隐私 -> 清除浏览数据 -> 缓存数据和 cookie）清除所有 photremium.com 本地存储。这样做不会影响您使用这些工具的能力。'
      },
      thirdParty: {
        title: '5. 第三方服务',
        subtitle: '我们使用的外部服务以及原因',
        intro: 'photremium.com 使用最少的一组受信任的第三方服务，严格确保基础设施和性能。这些服务均不会接收您的图像或任何个人身份信息。',
        headers: {
          service: '服务',
          purpose: '目的',
          dataShared: '数据共享',
          privacyPolicy: '隐私政策'
        },
        rows: [
          {
            service: 'Cloudflare 页面',
            purpose: '网站资产的托管和 CDN 交付',
            dataShared: 'IP 地址、HTTP 标头（标准）',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: '字体真棒',
            purpose: '从 CDN 加载的图标字体',
            dataShared: 'IP 地址（仅限 CSS 请求）',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: '谷歌字体',
            purpose: '字体加载（如果适用）',
            dataShared: 'IP 地址（仅限字体请求）',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: '我们不会与广告商、数据经纪人或上述基础设施提供商之外的任何其他第三方共享您的数据。'
      },
      analytics: {
        title: '6. 分析',
        subtitle: '聚合、尊重隐私的使用数据',
        introPrefix: '为了了解哪些工具受欢迎以及如何改进网站，我们可能会收集',
        introStrong: '汇总、匿名',
        introSuffix: '使用统计数据，例如：',
        points: [
          '每个工具的页面浏览量（无用户识别）',
          '推荐来源（例如 Google 搜索、直接链接）——无个人数据',
          '国家级地理数据（不是城市或精确位置）',
          '用于兼容性分析的浏览器/设备类型'
        ],
        calloutLabel: '没有任何数据与您个人相关。',
        calloutText: '我们不使用 Google Analytics 或 Meta Pixel。我们使用的任何分析都是隐私优先的工具（例如 Plasible 或类似工具）。'
      },
      children: {
        title: '7. 儿童隐私',
        subtitle: 'COPPA 和儿童安全合规性',
        p1: 'photremium.com 不会故意收集 13 岁以下（欧盟 GDPR 规定为 16 岁）以下儿童的任何个人信息。由于我们不收集任何用户的个人数据，因此年轻用户无需做任何特别的事情 - 该网站对每个人来说都同样安全。',
        p2Prefix: '如果您认为孩子以某种方式通过我们的联系表提交了个人信息，请立即联系我们：',
        p2Suffix: '我们将及时删除。'
      },
      rights: {
        title: '8. 您的权利',
        subtitle: 'GDPR、CCPA 和全球隐私权',
        intro: '由于 photremium.com 不收集任何个人身份信息，因此大多数数据主体权利的适用性并不重要 - 没有关于您的数据可供访问、更正或删除。尽管如此，我们完全承认并尊重以下权利：',
        points: [
          {
            label: '访问权',
            text: '您可以索取我们持有的有关您的任何数据的副本。 （除了匿名日志之外，没有其他任何内容。）'
          },
          {
            label: '纠正权',
            text: '您可以要求更正不准确的个人数据。'
          },
          {
            label: '删除权（“被遗忘权”）',
            text: '您可以要求删除我们持有的任何个人数据（GDPR 第 17 条、CCPA）。'
          },
          {
            label: '反对/选择退出的权利',
            text: '您可以使用浏览器级选择退出或广告拦截工具选择退出任何未来的分析收集。'
          },
          {
            label: '数据可移植性的权利',
            text: '您的所有作品都会直接下载到您的设备 - 无需导出请求。'
          }
        ],
        callout: '这些权利适用于全球所有用户，无论司法管辖区如何——我们采用最高标准 (GDPR) 作为基准。'
      },
      security: {
        title: '9. 安全',
        subtitle: '我们如何保护您的体验',
        intro: '最安全的数据是从未被收集的数据。 photremium.com 客户端架构意味着服务器漏洞无法暴露您的文件，因为您的文件永远不会在我们的服务器上。其他安全措施包括：',
        points: [
          {
            label: 'HTTPS 强制执行',
            text: '您的浏览器和我们的 CDN 之间的所有流量均通过 TLS 1.2+ 和 HSTS 进行加密。'
          },
          {
            label: '内容安全策略 (CSP)',
            text: '严格的标头可防止跨站点脚本编写和内联脚本注入。'
          },
          {
            label: '定期依赖性审计',
            text: '我们定期审核和更新 npm 软件包以修补已知漏洞。'
          }
        ],
        disclosurePrefix: '负责任的披露',
        disclosureTextPrefix: '发现安全问题？给我们发电子邮件：',
        disclosureTextSuffix: '我们将在 48 小时内回复。'
      },
      changes: {
        title: '10. 本政策的变更',
        subtitle: '我们如何处理政策更新',
        intro: '我们可能会不时更新本隐私政策，以反映我们的做法、工具或法律要求的变化。当我们这样做时：',
        points: [
          {
            label: '“最后更新”',
            text: '本页顶部的日期将被修改。'
          },
          {
            label: '重大变化',
            text: '将通过主页上的显着通知进行传达至少 30 天。'
          },
          {
            label: '以前的版本',
            text: '本政策的内容将被存档并根据要求提供。'
          }
        ],
        outro: '在更改发布后继续使用 photremium.com 即表示接受更新后的政策。我们鼓励您定期查看此页面。'
      },
      contact: {
        title: '11. 联系方式和数据请求',
        subtitle: '联系我们了解隐私问题',
        p1Prefix: '对于与本隐私政策相关的任何问题、疑虑或正式数据请求，请联系我们。我们的目标是在以下范围内回复所有与隐私相关的询问',
        p1Strong: '5个工作日'
      }
    },
    footer: {
      privacyQuestionsTitle: '隐私问题？',
      privacyQuestionsDesc: '将您的隐私问题、数据请求或疑虑发送给我们，我们将立即回复。',
      versionHistoryTitle: '版本历史',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
/* ————— Common / shared UI strings ————— */
  common: {
    new: '新功能！',
    download: '下载',
    downloadAll: '下载全部',
    downloadAs: '下载格式：',
    zip: 'ZIP',
    separate: '单独',
    upload: '上传',
    dragDrop: '将图片拖放到此处，或点击浏览',
    remove: '删除',
    reset: '重置',
    apply: '应用',
    cancel: '取消',
    clear: '清除',
    close: '关闭',
    save: '保存',
    processing: '处理中...',
    noFiles: '未选择文件',
    selectFiles: '选择文件',
    or: '或',
    browseFiles: '浏览文件',
    dropHere: '将图片拖放到此处',
    chooseFiles: '选择文件',
    pasteHint: '您也可以粘贴图片',
    quality: '质量',
    width: '宽度',
    height: '高度',
    format: '格式',
    compression: '压缩',
    preview: '预览',
    original: '原图',
    result: '结果',
    before: '处理前',
    after: '处理后',
    startOver: '重新开始',
    startOverConfirm: '删除所有图片并重新开始？',
    addMoreImages: '添加更多图片',
    addImage: '添加图片',
    images: '图片',
    totalSize: '总大小',
    size: '大小',
    type: '类型',
    unsavedEdits: '您有未保存的编辑。确定要离开此页面吗？',
    compareSlider: '对比滑块',
    toggleToolsPanel: '切换工具面板',
    closePanel: '关闭面板',
    zoomIn: '放大',
    zoomOut: '缩小',
    fit: '适应',
    none: '无',
  },
  compressor: {
    seo: {
      uploadTitle: '图片压缩 — 免费在线压缩 JPG、PNG、SVG、GIF | photremium.com',
      uploadDesc: '免费在线压缩 JPG、PNG、SVG 和 GIF 图片。在保持视觉质量的同时减小高达 80% 的文件大小。无需注册。',
      uploadKeywords: '图片压缩, JPG 压缩, PNG 压缩, 减小图片大小, 图片优化',
      workspaceTitle: '正在压缩图片 — photremium.com 图片压缩器',
      workspaceDesc: '调整压缩级别并下载优化后的图片。',
      workspaceKeywords: '图片压缩, 批量压缩',
    },
    title: '图片压缩',
    desc: '将 JPG、PNG 和 GIF 图片压缩高达 80%。快速且私密——完全在浏览器中运行。',
    toCompress: '要压缩的图片',
    compressionForAll: '所有图片的压缩设置',
    summary: '摘要',
    originalSize: '原始大小',
    compressed: '压缩后',
    saved: '节省',
    compressionLabel: '压缩：',
    compressing: '压缩中…',
    compressDownload: '压缩并下载',
    lowQualityWarning: '高压缩可能会明显降低图像清晰度。',
    blog: {
      tocTitle: '目录',
      title: '图片压缩博客',
      formatsIntro: '我们的工具支持所有图片格式，因此您可以顺畅压缩任何图片。完整格式列表如下：',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. 什么是图片压缩器？',
          paragraphs: [
            '图片压缩器是一种软件工具或在线服务，可在尽量保持视觉质量的同时减小图片文件大小。不过，压缩过度会导致画质明显下降。',
          ],
          listTitle: '类型：',
          bullets: [
            '有损压缩：通过删除部分图像数据来减小文件大小，可能会降低质量，但轻度压缩通常肉眼不易察觉。',
            '无损压缩：在不影响图像视觉质量的情况下减小文件大小。',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. 为什么选择我们的工具？',
          bullets: [
            '我们的 AI 图片压缩工具可在各类设备上稳定运行，并提供尽可能好的结果。',
            '您可以一键批量压缩多张图片（甚至 100+ 张）。',
            '无需将图片上传到我们的服务器，全部处理都在您的本地浏览器完成。',
            '我们的图片压缩工具永久免费，您也可以分享给朋友使用。',
            '您可以按需求自定义压缩百分比。',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. 分步指南',
          steps: [
            {
              heading: '1. 选择要压缩的图片。',
              bullets: [
                '将图片拖放到上传区域。',
                '也可以复制图片后使用 (Ctrl + V) 粘贴到上传区域。',
                '还可以点击选择按钮，通过文件管理器选择图片。',
              ],
            },
            {
              heading: '2. 然后选择压缩百分比。',
              bullets: [
                '横向滑块可让您更轻松地选择压缩比例。建议参考以下区间以获得更准确结果。',
              ],
              table: {
                headers: ['压缩百分比', '结果'],
                rows: [
                  ['1%  到  40%', '最佳质量'],
                  ['41%  到  60%', '普通质量（推荐）'],
                  ['61%  到  100%', '较差质量'],
                ],
              },
            },
            {
              heading: '3. 查看您节省的存储空间。',
              paragraphs: [
                '所有大小指标都会实时显示。您可以清晰看到总共节省了多少空间，并根据需求调整压缩级别以获得合适的文件大小。',
              ],
            },
            {
              heading: '4. 通过切换按钮选择下载方式。',
              bullets: [
                'ZIP：当您压缩多张图片时会显示该选项。选择后会将所有压缩图片打包为一个 ZIP 文件（适合大量图片）。',
                '分别下载：选择后每张图片将单独下载，而不是合并成一个 ZIP（适合少量图片，少于 10 张）。',
              ],
            },
            {
              heading: '5. 压缩并下载图片。',
              paragraphs: [
                '点击此按钮后，系统会按照您选择的下载方式自动下载所有压缩后的图片。',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. 图片压缩的优势。',
          bullets: [
            '降低存储成本：压缩后文件更小，可显著减少存储占用。',
            '加载更快：压缩图片加载速度更快，可提升网站或应用的用户体验。',
            '解决 Gmail 附件限制：Gmail 附件上限为 25MB，压缩后可发送更多文件。',
            '分享与传输更快：大文件传输耗时更长，压缩可节省时间与流量。',
            '优化演示文稿：未压缩图片会让演示文件过大、运行卡顿，压缩后可明显减小体积。',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. 支持的格式。',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },
  converter: {
    seo: {
      uploadTitle: '图片转换 — 免费在线转换 PNG、JPG、WEBP、GIF、SVG | photremium.com',
      uploadDesc: '在 JPG、PNG、WEBP、GIF、SVG、TIFF、BMP 之间转换图片。免费在线图片格式转换——快速、私密、无需注册。',
      uploadKeywords: '图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',
      workspaceKeywords: '图片转换, 格式转换, 批量转换',

      routeKeywords: {

        'png-to-jpg': 'png 要转换的图片 jpg, png to jpg, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'jpg-to-png': 'jpg 要转换的图片 png, jpg to png, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'png-to-webp': 'png 要转换的图片 webp, png to webp, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'jpg-to-webp': 'jpg 要转换的图片 webp, jpg to webp, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'webp-to-jpg': 'webp 要转换的图片 jpg, webp to jpg, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'webp-to-png': 'webp 要转换的图片 png, webp to png, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'gif-to-jpg': 'gif 要转换的图片 jpg, gif to jpg, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'gif-to-png': 'gif 要转换的图片 png, gif to png, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'bmp-to-jpg': 'bmp 要转换的图片 jpg, bmp to jpg, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'bmp-to-png': 'bmp 要转换的图片 png, bmp to png, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'svg-to-png': 'svg 要转换的图片 png, svg to png, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'svg-to-jpg': 'svg 要转换的图片 jpg, svg to jpg, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'tiff-to-jpg': 'tiff 要转换的图片 jpg, tiff to jpg, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'tiff-to-png': 'tiff 要转换的图片 png, tiff to png, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'jpg-to-gif': 'jpg 要转换的图片 gif, jpg to gif, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'png-to-gif': 'png 要转换的图片 gif, png to gif, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'jpg-to-bmp': 'jpg 要转换的图片 bmp, jpg to bmp, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'png-to-bmp': 'png 要转换的图片 bmp, png to bmp, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'webp-to-gif': 'webp 要转换的图片 gif, webp to gif, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'jpg-to-ico': 'jpg 要转换的图片 ico, jpg to ico, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'png-to-ico': 'png 要转换的图片 ico, png to ico, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'jpg-to-svg': 'jpg 要转换的图片 svg, jpg to svg, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'png-to-svg': 'png 要转换的图片 svg, png to svg, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'webp-to-svg': 'webp 要转换的图片 svg, webp to svg, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'gif-to-svg': 'gif 要转换的图片 svg, gif to svg, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'bmp-to-svg': 'bmp 要转换的图片 svg, bmp to svg, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

        'tiff-to-svg': 'tiff 要转换的图片 svg, tiff to svg, 图片转换, PNG 转 JPG, JPG 转 PNG, WEBP 转换',

      },
    },
    title: '图片转换',
    desc: '在 JPG、PNG、WEBP、GIF、SVG、TIFF、BMP 等多种格式之间转换图片。一次批量转换多个文件。',
    toConvert: '要转换的图片',
    convertSettings: '转换设置',
    detected: '检测到',
    convertTo: '转换为',
    converting: '转换中…',
    convertToFormat: '转换为 {format}',
    popularConversions: '热门转换',
    convertingTo: '正在转换为：',
    all: '全部',
  },
  resizer: {
    seo: {
      uploadTitle: '调整图片尺寸 — 免费在线调整 JPG、PNG、SVG、GIF | photremium.com',
      uploadDesc: '按像素或百分比在线调整图片大小。在保持质量的同时调整 JPG、PNG、SVG 和 GIF 图片尺寸。',
      uploadKeywords: '调整图片尺寸, 图片大小调整, JPG 调整, PNG 调整',
      workspaceTitle: '正在调整图片尺寸 — photremium.com',
      workspaceDesc: '免费在线调整图片大小。',
      workspaceKeywords: '调整图片尺寸',
    },
    title: '调整图片尺寸',
    desc: '按像素、百分比、厘米或英寸调整 JPG、PNG、SVG 和 GIF 图片大小。一次批量调整多个文件。',
    toResize: '要调整的图片',
    resizeSettings: '调整设置',
    resizeBy: '调整依据：',
    byPixels: '像素',
    byPercentage: '百分比',
    byCentimeters: '厘米',
    byInches: '英寸',
    advanced: '高级选项',
    lockAspect: '锁定宽高比',
    unlockAspect: '解锁宽高比',
    dontEnlarge: '如果比原图小则不放大',
    resizing: '调整中…',
    resizeDownload: '调整并下载',
    blog: {
      tocTitle: '目录',
      title: '图片尺寸调整博客',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. 为什么要使用图片尺寸调整工具？',
          paragraphs: [
            '图片尺寸调整工具是一种用于修改图片尺寸（宽高）的工具/软件。您可以调整高度、宽度或两者，以获得所需大小。对于有图片上传/发布尺寸限制的社交平台尤其有用。',
          ],
          listTitle: '例如：',
          bullets: [
            'Instagram 帖子：1080 x 1080px（方形）',
            'Facebook 帖子：1200 x 630px',
            'X（Twitter）帖子：1200 x 675px',
            'Instagram Story：1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. 为什么选择我们的图片尺寸调整工具？',
          paragraphs: [
            '我们的 AI 图片尺寸调整工具可让您高精度、超快速地调整图片大小。工具可在任意设备上流畅运行，无需安装应用。所有功能都可在浏览器中在线使用。',
          ],
          bullets: [
            '您可以一次调整多张图片（甚至 100+）。在高性能设备上，400–500 张也可在几秒内处理完成。',
            '所有处理都在本地浏览器中完成。无需上传到服务器，图片不会离开您的设备。',
            '支持多种尺寸单位。',
            '只需勾选一个选项即可在调整后保持原始宽高比。',
            '批量调整时可选择逐张下载或打包 ZIP 下载。',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. 分步指南',
          steps: [
            {
              heading: '首先，选择要调整大小的图片（可单张或多张）。支持多种选择方式。',
              bullets: [
                '将图片拖拽到上传框中。',
                '也可以使用 “Ctrl + V” 快捷键粘贴图片。',
                '或点击 “Choose Files” 按钮从文件管理器选择。',
              ],
            },
            {
              heading: '然后，选择尺寸单位。目前支持：',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: '选择单位后，设置宽度和高度。也可通过勾选项保持宽高比。',
            },
            {
              heading: '如果不希望图片大于原图，请勾选 “Don’t enlarge if original is smaller”。',
            },
            {
              heading: '接下来选择下载方式。',
              bullets: [
                '若希望所有结果打包为一个 zip 文件，请选择 ZIP。',
                '若希望每张图片单独下载，请选择 “separate”。',
              ],
            },
            {
              heading: '最后点击 “Resize & Download” 按钮，即可按所选方式下载。',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. 图片尺寸调整工具的优势：最大优势是帮助图片在网页与社交媒体中正确呈现。',
          tocLabel: '4. 图片尺寸调整工具的优势',
          bullets: [
            '提升 UX：正确的图片尺寸与排版可显著改善用户体验。',
            '适配社交媒体：许多平台有尺寸限制，工具可帮助快速达标。',
            '支持响应式设计：开发者通常需要为不同设备准备不同尺寸图片。',
            '更优选择：相比强行拉伸或过度裁剪导致比例失真，尺寸调整通常更合理。',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. 支持格式：我们的图片尺寸调整工具支持几乎所有图片格式。支持列表如下：',
          tocLabel: '5. 支持格式',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },
  cropper: {
    seo: {
      uploadTitle: '图片裁剪 — 免费在线裁剪 JPG、PNG、GIF | photremium.com',
      uploadDesc: '在线轻松裁剪 JPG、PNG 和 GIF 图片。使用可视编辑器进行预设比例或自由裁剪。',
      uploadKeywords: '图片裁剪, JPG 裁剪, PNG 裁剪',
      workspaceTitle: '正在裁剪图片 — photremium.com',
      workspaceDesc: '免费在线裁剪图片。',
      workspaceKeywords: '图片裁剪',
    },
    title: '图片裁剪',
    desc: '使用可视编辑器裁剪 JPG、PNG 和 GIF 等图片。支持预设比例或自由裁剪。',
    toCrop: '要裁剪的图片',
    cropSettings: '裁剪设置',
    widthPx: '宽度 (像素)',
    heightPx: '高度 (像素)',
    positionX: 'X 位置 (像素)',
    positionY: 'Y 位置 (像素)',
    cropTemplate: '裁剪模板',
    landscape: '横向',
    portrait: '纵向',
    square: '正方形',
    freeform: '自由形式',
    cropping: '裁剪中…',
    cropDownload: '裁剪并下载',
    cropDownloadAll: '全部裁剪并下载',
    saveNext: '保存并继续',
    croppedNofTotal: '已裁剪 {n} / {total} 张。',
    downloadN: '下载 {n} 张',
    blog: {
      tocTitle: '目录',
      title: '图片裁剪博客',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. 为什么要使用图片裁剪工具？',
          paragraphs: [
            '图片裁剪工具是一种用于将图片裁剪为所需形状的软件工具。它被广泛用于保留图片中需要的部分，并删除外部不需要的区域，以满足各种用途。该工具提供一个可调整的裁剪框，您可以将其移动到希望裁剪的位置。',
          ],
          listTitle: '例如：',
          bullets: [
            '从合影中裁出你自己。',
            '从名单中裁出你的名字。',
            '从整屏截图中裁出进度条。',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. 为什么选择我们的图片裁剪工具？',
          paragraphs: [
            '我们的图片裁剪工具可让您非常快速且精准地裁剪图片。您只需在任意图片上将裁剪框调整到想要裁剪的位置和尺寸即可。图片选择几乎支持所有图片格式。',
          ],
          bullets: [
            '您可以裁剪任意数量的图片，具体取决于设备支持能力。如果您的设备性能足够高，甚至可以一次裁剪 100+ 张图片而不会卡顿或出现其他问题。',
            '您的图片会在本地浏览器中处理。无需将任何图片上传到我们的服务器，因此图片不会离开您的设备。您可以在无安全风险的情况下裁剪私人图片。',
            '许多工具会提示无效图片格式错误。我们的图片裁剪工具通过支持几乎所有图片格式来解决该问题。',
            '如果您一次裁剪很多图片，我们的工具支持按您的偏好将裁剪后的图片打包为 ZIP 下载，或逐张单独下载。',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. 分步指南',
          steps: [
            {
              heading: '1. 首先，选择您要裁剪的图片。我们的图片裁剪工具也支持一次选择多张图片。',
              bullets: [
                '将图片拖放到投放框中进行裁剪。',
                '您也可以点击裁剪框中的 choose files 按钮，通过文件资源管理器选择图片。',
                '也支持使用 Ctrl + V 快捷键将图片粘贴到投放框中。',
              ],
            },
            {
              heading: '2. 然后，在图片上调整裁剪框的大小和位置进行裁剪。',
            },
            {
              heading: '3. 您还可以通过手动输入高度、宽度、水平位置和垂直位置的数值来调整裁剪框。',
            },
            {
              heading: '4. 您还可以使用一些现成模板：',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. 然后，您需要选择一个下载选项。',
              bullets: [
                'ZIP：如果您一次裁剪多张图片并希望将所有裁剪后的图片作为一个文件下载，请选择此选项。',
                'Separate：如果您希望将所有裁剪后的图片分别下载，请在切换按钮中选择此选项。',
              ],
            },
            {
              heading: '6. 然后点击 Crop & Download 按钮，即可按您预设的尺寸下载所有裁剪后的图片。',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. 图片裁剪的优势：图片裁剪工具在数字世界中提供了多种好处。以下列出其中一些：',
          tocLabel: '4. 图片裁剪的优势',
          bullets: [
            '让图片适配框架：图片裁剪工具可帮助您将图片正确放入框架中。该框架可以在网页或任意社交媒体平台上。',
            '提升用户体验：正确的图片摆放可以提升用户体验，因此图片裁剪工具能显著改善 UX。',
            '去除不需要的边缘：您可以去除图片中不需要的边缘，使其更精致。',
            '分离目标对象：您也可以从合影中单独裁出自己。',
            '节省存储空间：裁剪图片会删除原图中多余区域，仅保留需要部分，因此能有效节省存储。',
            '优化演示文稿：如果一个包含 10 张未裁剪图片的普通演示约占 30MB，那么同样内容使用裁剪图片后可能仅占约 10MB。',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. 支持格式：',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },
  photoEditor: {
    seo: {
      title: '在线照片编辑器 — 免费添加文字、特效、相框 | photremium.com',
      desc: '免费在线编辑照片——添加文字、特效、相框、贴纸等。在浏览器中运行的简单图片编辑工具。',
      keywords: '照片编辑器, 在线图片编辑, 免费照片编辑, 图片添加文字',
    },
    title: '照片编辑器',
    desc: '用文字、特效、相框和贴纸美化您的照片。满足所有图片需求的简单编辑工具。',
    toEdit: '要编辑的图片',
    textTypography: '文字与排版',
    textTypographyDesc: '使用各种字体、颜色、阴影和对齐选项添加自定义文字。',
    filtersEffects: '滤镜与特效',
    filtersEffectsDesc: '应用专业滤镜，调整亮度、对比度、饱和度等。',
    framesStickers: '相框与贴纸',
    framesStickersDesc: '用漂亮的相框和有趣的贴纸装饰您的图片。',
  },
  removeBg: {
    seo: {
      uploadTitle: '去除图片背景 — 免费在线去除 | photremium.com',
      uploadDesc: '高精度快速去除图片背景。免费在线背景去除工具——完全在浏览器中运行。',
      uploadKeywords: '背景去除, 去除背景, 透明背景, 抠图',
      workspaceTitle: '正在去除背景 — photremium.com 背景去除工具',
      workspaceDesc: '免费在线去除图片背景。',
      workspaceKeywords: '背景去除',
    },
    title: '背景去除',
    desc: '通过高级边缘检测即时从图片中去除背景。100% 免费，完全在浏览器中运行——无需上传，无服务器。',
    toRemoveBg: '去除背景',
    backgroundRemover: '背景去除工具',
    processingProgress: '处理进度',
    processingNImages: '正在处理 {n} 张图片…',
    allNProcessed: '所有 {n} 张图片已处理完毕！',
    nOfTotalDone: '{n} / {total} 已完成',
    fileName: '文件名',
    dimensions: '尺寸',
    status: '状态',
    statusDone: '✓ 完成',
    statusProcessing: '⏳ 处理中',
    statusError: '✗ 错误',
    statusPending: '⏸ 等待中',
    badgeDone: '完成',
    badgeProcessing: '处理中…',
    badgeError: '错误',
    removingBg: '正在去除背景…',
    retry: '重试',
    downloading: '下载中…',
    nextImage: '下一张图片',
  },
  watermark: {
    seo: {
      uploadTitle: '添加水印 — 免费添加文字或图片水印 | photremium.com',
      uploadDesc: '几秒内为照片添加文字或图片水印。免费、快速、私密。',
      uploadKeywords: '添加水印, 文字水印, Logo 水印',
      workspaceTitle: '正在添加水印 — photremium.com 水印工具',
      workspaceDesc: '免费在线为图片添加水印。',
      workspaceKeywords: '添加水印',
    },
    title: '添加水印',
    desc: '为图片添加文字或 Logo 水印。自定义字体、不透明度、大小、位置等。完全在浏览器中运行。',
    toWatermark: '要添加水印的图片',
    watermarkTools: '水印工具',
    addText: '添加文字',
    addImage: '添加图片',
    layersN: '图层 ({n})',
    noLayers: '暂未添加图层',
    textLayer: '文字图层',
    imageLayer: '图片图层',
    watermarkDownloadAll: '加水印并下载全部',
    watermarkDownload: '加水印并下载',
    nextImage: '下一张图片',
    privateMode: '隐私模式',
    privateModeOn: '隐私模式已开启：此图片只允许移动和调整水印大小…',
    privateModeHint: '启用隐私模式只调整位置和大小…',
    privateModeActive: '隐私模式——只允许移动、调整大小和更改字体大小',
    selectToEdit: '选择图片或文字开始编辑',
    bold: '粗体',
    italic: '斜体',
    underline: '下划线',
    bgColor: '背景色',
    textColor: '文字颜色',
    alignLeft: '左对齐',
    alignCenter: '居中对齐',
    alignRight: '右对齐',
    opacity: '不透明度',
    stroke: '描边',
    strokeWidth: '描边宽度',
    strokeColor: '描边颜色',
    tileRepeat: '平铺/ 重复',
    tilePattern: '平铺图案',
    spacing: '间距',
    snapToCenter: '吸附到中心',
    duplicate: '复制',
    delete: '删除',
    flipHorizontal: '水平翻转',
    flipVertical: '垂直翻转',
    rotateLeft: '向左旋转',
    rotateRight: '向右旋转',
    cornerRadius: '圆角半径',
    borderStroke: '边框 / 描边',
    borderWidth: '边框宽度',
    color: '颜色',
    style: '样式',
    hide: '隐藏',
    show: '显示',
    lock: '锁定',
    unlock: '解锁',
    solid: '实线',
    dashed: '虚线',
    dotted: '点线',
    double: '双线',
    tileSingle: '单个',
    tile2x2: '2×2 网格',
    tile3x3: '3×3 网格',
    removeAllConfirm: '删除所有图片和水印？',
    dimMismatch: '上传的图片尺寸不同。为获得最佳效果，请上传相同分辨率的图片，或逐张添加水印。',
    clearBackground: '清除背景',
    typeHere: '在此输入...',
    linkCorners: '关联圆角',
    separateCorners: '分离圆角',
    blog: {
      tocTitle: '目录',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: '水印工具概览',
          title: '如何在线为图片添加水印 — Photremium 水印工具完整指南',
          paragraphs: [
            '你刚刚完成了一张精美照片的编辑。也许是给店铺的产品图、客户拍摄的肖像，或是你花了数小时打磨的数字艺术作品。现在每个创作者最终都会面对的问题来了：在分享之前，如何保护它？',
            '大多数专业人士的答案是：水印 — 而且理由充分。恰当放置的水印就像作品上的永久签名，让作品可追溯、可识别，并且更难被盗用。',
            '问题在于：多数在线工具要么笨重难用，要么被订阅锁住，要么输出的水印过于厚重，直接破坏图片。',
            'Photremium 的水印工具正是为了解决这些问题而生。它是一个完全基于浏览器的水印工作区，免费、无需账号，直接在浏览器内运行，从不把文件上传到服务器。一切都在本地完成、速度很快，而且它提供的创意控制不输桌面软件。本指南将带你了解它如何工作、适合谁使用，以及如何每次都得到最佳结果。',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: '什么是水印',
          title: '水印是什么？为什么重要？',
          paragraphs: [
            '在深入工具之前，先了解水印的作用以及为什么这么多摄影师、设计师和内容创作者都认为它不可或缺。',
            '水印是叠加在图片上的可见内容 — 通常是文字、logo 或版权符号 — 用于标识内容的创作者或所有者。与元数据不同（元数据隐藏在文件中，可在几秒内移除），水印是视觉性地嵌入在图像里。你无法通过右键轻松移除它而不明显降低图像质量。',
          ],
          subSections: [
            {
              title: '创作者为什么使用水印',
              paragraphs: [
                '给图像加水印的实际原因主要归结为三个核心点。',
              ],
              bullets: [
                '归属识别。当你的作品在社交平台、Pinterest 看板或博客中传播时，原始署名往往会丢失。水印可以确保你的名字或品牌随图像一起传播。',
                '防盗威慑。多数随意盗图者会选择最容易的路径。一个专业、位置合理、略带透明度的水印会传递明确的信号：这张图片属于认真保护作品的人。',
                '客户作品保护。摄影师在客户最终付款前提供预览时，常用水印来防止对方未经支付就使用预览图。一个低调的水印能达到保护效果，同时不影响评估。',
              ],
            },
            {
              title: '哪些人应该为图片加水印',
              paragraphs: [
                '如果你属于以下任何一种类型，在在线分享之前加水印不是可选项 — 而是必要：',
              ],
              bullets: [
                '与客户分享作品集的自由摄影师',
                '发布作品样张的平面设计师',
                '在授权前展示产品照片的电商卖家',
                '在社交平台发布作品的数字艺术家',
                '图片经常被转载的博主与内容创作者',
                '建立可识别品牌的图库贡献者',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: '工作区面板',
          title: 'Photremium 水印工具内部：为真实工作流打造的三面板工作区',
          paragraphs: [
            'Photremium 水印工具与普通在线水印工具的最大区别，在于其工作区设计。它不是简单的“输入文字、选位置、完成”，而是提供三面板布局，类似专业设计软件 — 但完全在浏览器中运行，无需安装。',
          ],
          subSections: [
            {
              title: '左侧画布面板',
              paragraphs: [
                '画布面板占据屏幕最大区域，实时展示水印应用后的效果。你做的每一项调整 — 改透明度、移动文字层、缩放 logo — 都会立即反映在画布上。没有“预览”按钮，所见即所得。',
                '画布包含内置缩放工具条，方便你放大精确对齐或缩小查看整体。Zoom-to-fit 会根据屏幕大小自动计算最佳初始缩放，即便是高分辨率图片也能舒适显示。当你拖动图层接近水平或垂直中心时，会出现对齐辅助线，水印会自动吸附到中心，精度体验与 Photoshop 类似。',
              ],
            },
            {
              title: '右侧设置面板',
              paragraphs: [
                '右侧面板是控制中心。在这里管理水印图层、调整外观并触发最终导出。桌面端它固定在右侧；移动端则以底部面板形式滑出 — 通过浮动齿轮按钮触发 — 不遮挡画布。',
                '右侧面板内有图层管理器，列出你添加的每个水印元素。每条图层包含类型（文字或图片）、名称或内容，以及三个快捷按钮：可见性切换（眼睛图标）、锁定位置、删除。',
              ],
            },
            {
              title: '左侧预览条（多图模式）',
              paragraphs: [
                '当你一次处理多张图片 — 例如产品图批量或整套人像 — 屏幕左侧会出现竖向缩略图条。这就是图片队列，展示每个已加载文件的缩略图。点击任何缩略图即可切换画布到对应图片，便于检查不同构图下的水印效果且不会丢失图层设置。',
                '缩略图条还会显示每个文件的大小（KB/MB）和格式（JPG、PNG、WEBP），方便你一眼了解当前处理对象。',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: '步骤指南',
          title: '步骤指南：如何在 Photremium 添加水印',
          paragraphs: [
            '本流程基于工具的真实工作方式 — 从拖拽上传系统到在下载前将水印永久写入图像的画布渲染引擎。',
          ],
          steps: [
            {
              heading: '步骤 1 — 上传你的图片',
              paragraphsBefore: [
                '打开 photremium.com/watermark-image。你会进入上传界面，页面中央是干净的拖放区域。',
                '你有三种方式把图片放入工具：',
              ],
              bullets: [
                'Drag and drop. 将一张或多张图片从桌面直接拖到投放区。工具支持 JPEG、PNG、WEBP 等标准格式。拖动文件到工作区时，会出现紫色边框和 “Drop images to add for watermarking” 提示，表示已识别拖放。',
                'Click to browse. 点击投放区内的 “Choose Files” 按钮打开文件选择器。可通过 Ctrl+Click（Windows）或 Cmd+Click（Mac）一次选择多张。',
                'Paste from clipboard. 若你已将图片复制到剪贴板（例如截图、其他应用或浏览器），在水印页面按 Ctrl+V（Mac 为 Cmd+V）即可直接加载到工作区。即使已加载多张图片也同样有效。',
              ],
              paragraphsAfter: [
                '第一张图片加载后，工作区会从上传界面切换为完整三面板编辑器，并以自动计算的适配缩放在画布中显示图片。',
              ],
            },
            {
              heading: '步骤 2 — 添加文字水印图层',
              paragraphsBefore: [
                '在右侧面板点击紫色 “Add Text” 按钮。画布上会出现一条新的文字图层，默认占位文字为 “Type here...”。',
                '你可以立即输入文字。文本会以默认大小的白色 Arial 在画布中实时渲染。选择文字图层后，顶部工具栏会显示，你可在其中自定义文字的各项属性：',
              ],
              bullets: [
                'Font family — 从 12 种内置字体中选择，包括 Arial、Georgia、Impact、Brush Script MT、Comic Sans MS 等',
                'Font size — 输入自定义像素值或使用增减控制',
                'Bold, italic, underline — 任意组合这些样式',
                'Text color — 点击颜色色块打开取色器，选择任何十六进制颜色',
                'Background color — 为文字添加背景色，形成标签/徽章视觉',
                'Stroke (outline) — 设置描边宽度与颜色，在明暗背景上确保可读性',
                'Opacity — 从 0%（不可见）到 100%（完全可见）滑动；多数水印位于 30%–60%',
                'Alignment — 在边界框内左对齐、居中或右对齐',
                'Rotation — 任意角度旋转，支持 0°、90°、180°、270° 的磁吸对齐',
              ],
              paragraphsAfter: [
                '移动文字时，点击并拖拽即可。若需像素级定位，使用键盘方向键（按住 Shift 可 10 像素步进）。调整文字框大小可拖动周围 8 个调整点（四角与四边）。',
              ],
            },
            {
              heading: '步骤 3 — 添加图片（Logo）水印图层',
              paragraphsBefore: [
                '如果你想使用 logo、签名或任何图片作为水印，点击右侧面板的蓝色 “Add Image” 按钮。系统会打开文件选择器，让你选择水印图片。',
                '工具会自动将水印图片缩放到画布宽度约 30%，保持原始比例，并居中放置。随后你可拖动到任意位置，使用角落手柄缩放（保持比例），或使用上方旋转手柄进行旋转。',
                '图像类型水印图层在右侧面板还提供以下控制项：',
              ],
              bullets: [
                'Opacity — 与文字图层相同，适合透明 PNG logo',
                'Flip horizontal / Flip vertical — 镜像翻转水印',
                'Border width, border color, and border style — 为 logo 水印添加可见边框',
                'Border radius — 圆角处理，可统一或分别控制每个角',
                'Rotation — 与文字图层相同的平滑旋转',
              ],
            },
            {
              heading: '步骤 4 — 设置平铺（可选）',
              paragraphsBefore: [
                '工具中更强大的功能之一是平铺 — 将水印按网格重复覆盖整个图片。当你希望图片无法被再次使用而不仅仅是标记时，这一点尤其有用。',
                '选中某个图层后，在工具栏中找到 tile 选项，可设置为：',
              ],
              bullets: [
                'None — 单一放置（默认）',
                'Grid 2×2 — 按 2 列 2 行的网格重复',
                'Grid 3×3 — 按 3×3 网格重复以获得更高覆盖密度',
              ],
              paragraphsAfter: [
                '你还可以调整平铺间距，用于控制重复间隔。画布会显示所有平铺副本的虚影预览，方便下载前确认覆盖效果。',
              ],
            },
            {
              heading: '步骤 5 — 使用图层管理器处理多个水印',
              paragraphsBefore: [
                '你可以添加任意数量的图层 — 自由混合文字与图片水印。右侧面板的图层管理器会列出全部图层，你可以：',
              ],
              bullets: [
                '用眼睛图标显示/隐藏单个图层 — 便于在不同水印版本间切换而无需删除',
                '锁定图层以防在编辑其他图层时误移',
                '永久删除图层',
              ],
              paragraphsAfter: [
                '点击列表中的任意图层条目即可在画布中选中该图层，无需在图片上寻找。',
              ],
            },
            {
              heading: '步骤 6 — 在多张图片之间切换',
              paragraphsBefore: [
                '如果你上传了多张图片，使用左侧缩略图条切换当前画布图片。你配置的水印图层会通用应用 — 导出时会渲染到批次中的每一张图。',
                '工具还会进行分辨率一致性检查。若图片尺寸差异较大（宽或高超过 5%），会出现提示，说明水印位置可能会因尺寸差异而变化。引擎会通过比例重定位算法处理：将水印位置按参考图片尺寸的百分比计算，再按相同比例应用到其他图片，确保不同分辨率也能保持一致视觉意图。',
              ],
            },
            {
              heading: '步骤 7 — 设置下载偏好',
              paragraphsBefore: [
                '单张图片处理时，点击画布下方的 “Download” 按钮直接保存水印图。文件名会自动在原名后加 “-watermarked”。JPEG 以 0.95 质量导出 — 在正常观看尺寸下几乎与原图无差异。PNG 则以无损 PNG 导出。',
                '批量处理（多张图片）时，右侧面板提供两种下载模式：',
              ],
              bullets: [
                'ZIP file — 所有水印图片打包成一个 ZIP，一键下载。工具会动态加载 JSZip 来处理压缩。',
                'Separate files — 每张图片单独下载，下载间隔会稍作延迟以避免浏览器限流。',
              ],
            },
            {
              heading: '步骤 8 — 下载并验证',
              paragraphsBefore: [
                '点击下载按钮（或批量的 “Watermark & Download All” 按钮）后，工具会在隐藏的 HTML5 canvas 上以原生分辨率渲染每张图片 — 而不是屏幕上的缩放预览尺寸。这意味着导出的图片保持 100% 原始像素尺寸，水印以正确比例绘制。打开下载文件并放大检查，确认水印位置与质量符合预期。',
                '如果哪里不对，回到工作区 — 你的图层仍在 — 调整后再下载即可。',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: '专业建议',
          title: '获得最佳效果的专业建议',
          bullets: [
            '使用半透明 PNG logo 更显专业。带透明背景、40–50% 不透明度的 logo 水印比实心文字更精致。使用前请在设计工具中将 logo 以带 alpha 透明通道的 PNG 导出。',
            '把水印放在裁剪会损失价值的位置。右下角是最常见的水印位置 — 也是最容易被裁掉的。想更强保护，可将水印放在图像重要区域，例如脸部、产品细节或焦点位置。对角平铺更难被移除且不会明显损坏图片。',
            '处理多图层时使用锁定功能。确定主水印位置后，先锁定该图层再添加其他图层，避免误操作导致移动。',
            '在明暗区域都测试。白色水印在亮天空上会消失，但在阴影处很清晰。添加细描边或淡背景色可保证在任何底图上都有良好可读性。',
            '键盘快捷键总能省时间。方向键每次移动 1 像素，Shift+Arrow 移动 10 像素。Delete 键可立刻删除选中图层。这些快捷操作比拖拽更高效。',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: '隐私与安全',
          title: '隐私与安全：为什么浏览器内处理很重要',
          paragraphs: [
            '很多创作者在使用在线工具时会担心：图片到底去了哪里？在基于服务器的水印工具中，图片会上传到服务商服务器，处理后再返回。这意味着未发布的作品、客户照片或敏感产品图会经过第三方基础设施。',
            'Photremium 水印工具在浏览器内本地处理一切。图片通过浏览器 File API 加载到设备内存，绝不会在网络上传输。水印渲染在 HTML5 canvas 上完成，完全在浏览器标签页内。当你关闭页面或点击 “Start Over”，所有图片数据都会从内存释放并丢弃。你的设备之外不会存储任何内容。',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: '最终总结',
          title: '为什么 Photremium 水印工具值得成为你的常用工作流',
          paragraphs: [
            '在线水印工具有很多，决定一个工具是否值得收藏，通常取决于速度、控制力与信任感的组合。',
            '速度很重要，因为水印不应为你的后期流程增加太多时间。Photremium 工具加载迅速、本地处理、数秒内以完整分辨率导出 — 即便是大批量也一样。无需等待服务器处理、无需排队，也不会因在线用户增加而延长渲染时间。',
            '控制力很重要，因为不合适的水印比不加水印更糟 — 会让品牌显得不专业。图层系统、属性级控制、实时画布预览与快捷键支持共同带来接近专业桌面软件的控制体验。',
            '信任感很重要，因为你的未发布作品很有价值。知道图片从不通过互联网到第三方服务器，你就可以放心为客户照片、未发布的产品图和敏感创作内容加水印，不必担心数据处理、服务器泄露或云服务政策变化。',
            '无论是给单张照片快速添加版权提示，还是在分享客户画廊前处理 200 张照片，Photremium 水印工具都能让你正确完成 — 完全免费、完全私密，并且足够灵活，使水印看起来像图片的一部分，而不是贴在上面。',
            '访问 photremium.com/watermark-image 立即试用。你的第一张水印图片真的只需三十秒。',
            'Photremium 提供一整套基于浏览器的图像编辑与处理工具。所有工具都在本地运行 — 你的图片始终留在你的设备上。',
          ],
        },
      ],
    },
  },
  qrGenerator: {
    seo: {
      inputTitle: '二维码生成器 — 免费创建与自定义 | photremium.com',
      inputDesc: '为 URL、文本、WiFi、联系人、邮件、Google 地图生成自定义二维码。自定义颜色、形状、相框和 Logo，以多种格式下载。',
      inputKeywords: '二维码生成器, 生成二维码, 自定义二维码',
      customizeTitle: '二维码自定义 — photremium.com',
      customizeDesc: '自定义二维码样式、颜色、相框和 Logo。以 PNG、JPG、SVG、WEBP、PDF 下载。',
      customizeKeywords: '二维码自定义, 二维码样式',
    },
    title: '二维码生成器',
    desc: '为 URL、文本、WiFi、联系人、邮件和地图生成、自定义和下载二维码。完全免费，在浏览器中运行。',
    generate: '生成',
    scanQrCode: '扫描二维码',
    tabUrl: '链接 / URL',
    tabText: '文本',
    tabWifi: 'WiFi',
    tabContact: '联系人',
    tabEmail: 'Gmail',
    tabMaps: 'Google 地图',
    enterUrl: '输入 URL',
    enterText: '输入文本',
    networkName: '网络名称 (SSID)',
    password: '密码',
    encryption: '加密方式',
    hiddenNetwork: '隐藏网络',
    contactName: '联系人姓名（可选）',
    phoneNumber: '电话号码',
    emailAddress: '电子邮件地址',
    subject: '主题（可选）',
    body: '正文（可选）',
    searchLocation: '搜索位置',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: '在此输入文字…',
    wifiNamePlaceholder: '我的 WiFi',
    passwordPlaceholder: '密码',
    contactPlaceholder: '张三',
    phonePlaceholder: '+86 XXX XXXX XXXX',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: '主题',
    bodyPlaceholder: '邮件正文…',
    locationPlaceholder: '搜索城市、地址或地点…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: '无',
    characters: '字符',
    qrGettingComplex: '二维码变得复杂——可能难以扫描。',
    qrTooComplex: '二维码太复杂了！大多数扫描仪无法读取。',
    generateCustomize: '生成并自定义',
    editQrData: '编辑二维码数据',
    styleShape: '样式与形状',
    colorTab: '颜色',
    framesTab: '相框',
    logoTab: 'Logo',
    templatesTab: '模板',
    fileFormatTab: '文件格式',
    dotShape: '点形状',
    cornerEyeOuter: '定位点——外部',
    cornerEyeInner: '定位点——内部',
    fgColor: '前景色',
    bgColor: '背景色',
    enableGradient: '启用渐变',
    gradientType: '渐变类型',
    linear: '线性',
    radial: '径向',
    gradientColor1: '渐变颜色 1',
    gradientColor2: '渐变颜色 2',
    suggestedGradients: '推荐渐变',
    selectFrame: '选择相框',
    selectLogo: '选择 Logo',
    uploadCustomLogo: '或上传自定义 Logo',
    uploadImage: '上传图片',
    customLogoApplied: '已应用自定义 Logo',
    premadeTemplates: '预设模板',
    templateHint: '点击模板立即应用样式。',
    downloadFormat: '下载格式',
    fgBgIdentical: '前景色和背景色相同——二维码将不可见！',
    fgBgSimilar: '前景色和背景色非常相似——二维码可能难以扫描。',
    preview: '预览',
    angle: '角度',
    downloadFormatBtn: '下载 {format}',
    pngDesc: '无损，支持透明',
    jpgDesc: '通用且常用的文件格式',
    webpDesc: '现代格式，最佳质量/大小',
    svgDesc: '可缩放矢量图形',
    pdfDesc: '印刷用文档',
    lat: '纬度：',
    lng: '经度：',
    qrCode: '二维码',
    scanMe: '扫描我',
    scanHere: '在此扫描',
    blog: {
      card1: {
        title: '1. 什么是二维码？',
        intro1: 'QR code 的全称是 “Quick Response code”（快速响应码）。由于其中存储的信息可以被极快解码，所以被称为 QR（快速响应）码。',
        intro2: '二维码是一种仅能被机器读取的二维数字编码。人类无法直接读取其中数据。它由模块组成，可存储文本、联系人号码、链接、Google 地图位置等信息。',
        inventionTitle: '二维码是如何被发明的：',
        inventionText: '二维码于 1994 年被发明。Masahiro Hara 与其团队当时在日本公司 Denso Wave 工作，该公司为 Toyota 生产汽车零部件。他们希望一种编码能比传统条形码存储更多信息，于是发明了二维码。',
        keyFeaturesTitle: '二维码的关键特性',
        keyFeatures: [
          {
            title: '二维码如何工作',
            text: '你输入文本或链接后即可生成对应二维码。二维码生成器会根据信息生成方块模块。每个模块代表一个比特，比特共同编码字符信息。',
          },
          {
            title: '二维码结构',
            text: '二维码包含三个较大的定位方块用于识别方向，并由许多小方块模块来存储比特（信息）。',
          },
          {
            title: '二维码数据容量',
            text: '通常二维码比条形码能存储更多信息。二维码本质上是条形码的高级版本，即二维条码。二维码通常可存储约 200 个字符。也可以存储到 400 个字符，但可能更难扫描。超过 400 个字符时，二维码会非常复杂，往往难以被正常扫描。',
          },
          {
            title: '二维码错误检测',
            text: '即使二维码部分信息被刮损或某些比特发生变化，通常仍可被扫描。二维码使用 Reed-Solomon 纠错技术来检测并在识别后修复错误。',
          },
        ],
        errorTitle: '二维码纠错级别：',
        errorIntro: '在不同场景下会使用不同的错误检测与纠错级别，如下所示：',
        errorHeaders: {
          level: '级别',
          recovery: '恢复能力',
          bestUse: '最佳使用场景',
        },
        errorRows: [
          {
            level: '低 (L)',
            recovery: '~7%',
            useCases: [
              '当二维码显示在数字屏幕、网站或较干净环境中时，适合使用此纠错级别。',
              '当二维码用于较少信息（如 Gmail、联系人号码或短文本）时也适用。',
            ],
          },
          {
            level: '中 (M)',
            recovery: '~15%',
            useCases: [
              '适用于张贴在较干净环境中的传单与海报，且损坏风险较低时。',
            ],
          },
          {
            level: '四分位 (Q)',
            recovery: '~25%',
            useCases: [
              '当二维码需要部署在工厂或户外等较恶劣环境时适合使用。',
              '当中心需要放置小 logo 并遮挡部分模块时，也需要该纠错级别。',
            ],
          },
          {
            level: '高 (H)',
            recovery: '~30%',
            useCases: [
              '用于二维码可能发生较重损坏的场景。',
              '当较大 logo 覆盖二维码中心时。',
              '以及需要较强视觉样式设计时。',
            ],
          },
        ],
      },
      card2: {
        title: '2. 为什么选择我们的二维码生成器？',
        intro: '我们的二维码生成器让生成过程极快、安全且简单。你可以对二维码进行深度定制，使其更高级、更专业，并与业务主题保持一致。从颜色设置到二维码内 logo 安装，所有定制功能永久免费提供。',
        strengths: [
          {
            title: '专业级定制：',
            text: '你可以按需生成并定制任意数量二维码，完全免费。所有功能均可免费使用，包括渐变色、不同模块形状、自定义 logo 等众多选项。',
          },
          {
            title: '多格式支持：',
            text: '我们的二维码生成器提供多种下载格式。你只需在下载前选择偏好的格式。目前支持以下格式：',
          },
          {
            title: '预设模板：',
            text: '你可以使用预设渐变配色和边框，让二维码看起来更专业。',
          },
          {
            title: '自定义 logo 支持：',
            text: '你可以上传品牌 logo，并自动适配到二维码中心。也可以从内置 logo 库中选择，库内提供 30+ 个 logo。',
          },
          {
            title: '实时预览：',
            text: '在定制过程中，你可以在实时预览面板中查看所有变化，所有效果都会动态即时更新。',
          },
          {
            title: '扫描指示：',
            text: '选择颜色时，如果组合可能导致难以扫描，系统会给出适当警告与提示。',
          },
        ],
        formatHeaders: {
          srNo: '序号',
          formats: '格式',
          description: '说明',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: '无损，支持透明' },
          { no: '2', format: 'JPG', description: '流行且通用的文件格式' },
          { no: '3', format: 'WEBP', description: '现代格式，质量与体积比更优' },
          { no: '4', format: 'SVG', description: '可缩放矢量图形' },
          { no: '5', format: 'PDF', description: '可直接打印文档' },
        ],
      },
      card3: {
        title: '3. 分步指南：',
        step1Intro: '首先，选择你要生成的二维码类别。无论是联系人、地图、链接还是文本。目前我们的二维码生成器提供以下类别：',
        categories: ['链接 / URL', '文本', 'WiFi', '联系人', 'Gmail', 'Google Maps'],
        step2: '选择类别后，将对应信息粘贴到文本框中。',
        step3Intro: '然后点击 Generate & Customize 打开定制面板。在定制面板中，你会看到以下子导航选项：',
        options: [
          {
            title: '样式与形状：',
            text: '在此部分，你可以将二维码模块形状改为多种样式，例如圆角、点状、横条、竖条、小方块等。',
          },
          {
            title: '颜色：',
            text: '你可以在此设置前景色与背景色。若想使用渐变色，可启用渐变功能，从内置库应用渐变或轻松创建自己的渐变。你还可以调整线性渐变角度，也支持径向渐变。添加多种颜色可打造更专业的渐变效果。',
          },
          {
            title: '边框：',
            text: '在这里你可以为二维码选择合适边框。所有边框都会自动适配到二维码中，你只需从内置库中选择一个即可。',
          },
          {
            title: 'Logo：',
            text: '选择边框后，你可以选择一个 logo 自动放置在二维码中心。也支持上传你的品牌自定义 logo。',
          },
          {
            title: '模板：',
            text: '如果你不想分别设置样式、形状、颜色和边框，可以直接套用预设模板。我们提供多款高质量模板，且永久免费。',
          },
          {
            title: '文件格式：',
            text: '最后，选择你希望下载二维码的文件类型。支持多种常见格式，包括 PNG、WEBP、SVG、PDF 等。',
          },
          {
            title: '编辑二维码数据：',
            text: '你还可以在不丢失已选定制设置的情况下编辑二维码数据。',
          },
        ],
        finalStep: '然后只需点击下载按钮，二维码就会按你的定制设置并以所选格式立即下载，且无需任何费用。',
      },
      card4: {
        title: '4. 优势：',
        intro: '二维码将现实世界与数字体验连接起来。它是分享链接、联系人或位置信息最快的方式。你只需扫描二维码即可即时访问信息。因此，二维码因高效且用途广泛，在商业和数字场景中非常流行。',
        benefits: [
          {
            title: '长期可用：',
            text: '二维码本身没有到期时间，可长期使用。扫描后可即时提供其中存储的信息。由于其保存的是固化编码的数字指令，信息不会自行丢失。',
          },
          {
            title: '离线可扫：',
            text: '即使离线也可以扫描二维码。手机摄像头会解码二维码图案，并读取其中存储的信息。',
          },
          {
            title: '零成本：',
            text: '由于这类二维码不需要服务器重定向或额外资源，因此可永久免费使用。',
          },
        ],
      },
    },
  },
  qrScanner: {
    seo: {
      title: '二维码扫描器 — 通过摄像头或图片扫描二维码 | photremium.com',
      desc: '通过摄像头或上传图片即时扫描二维码。检测 URL、文本、WiFi、联系人等。免费、快速、私密。',
      keywords: '二维码扫描器, 扫描二维码, 二维码读取器',
    },
    title: '二维码扫描器',
    desc: '通过摄像头即时扫描二维码或上传图片。快速、私密且安全——一切在浏览器中运行。',
    generateQrCode: '生成二维码',
    scan: '扫描',
    cameraScanner: '摄像头扫描',
    uploadImage: '上传图片',
    pointCamera: '将摄像头对准二维码',
    startCamera: '启动摄像头',
    loading: '加载中…',
    dropQrImage: '将二维码图片拖放到此处',
    toScan: '进行扫描',
    supportedFormats: '支持 JPG、PNG、GIF、WEBP',
    ctrlVPaste: 'Ctrl+V 粘贴',
    scanFromGallery: '从相册扫描',
    instantScanning: '即时扫描',
    instantScanningDesc: '从摄像头或上传图片实时检测二维码',
    private100: '100% 私密',
    private100Desc: '所有处理在浏览器中完成，无任何上传',
    multiFormat: '多格式支持',
    multiFormatDesc: '检测 URL、文本、WiFi、联系人、邮件、电话等',
    accessingCamera: '正在访问摄像头…',
    cameraDenied: '摄像头访问被拒绝。请授予摄像头权限后重试。',
    noCamera: '此设备未找到摄像头。',
    cameraError: '无法访问摄像头。请重试。',
    videoError: '无法启动视频播放。',
    switchError: '无法切换摄像头。',
    tryAgain: '重试',
    switchCamera: '切换摄像头',
    stop: '停止',
    noQrFound: '未找到二维码',
    couldNotRead: '无法读取图片',
    scannerFailed: '扫描器加载失败',
    noQrFoundDesc: '图片中未检测到二维码。请尝试其他图片或使用摄像头扫描。',
    qrScanned: '二维码扫描成功！',
    openLink: '打开链接',
    copied: '已复制！',
    copy: '复制',
    share: '分享',
    scanAgain: '重新扫描',
    network: '网络',
    password: '密码',
    security: '安全性',
    unknown: '未知',
    typeText: '文本',
    typeUrl: 'URL',
    typeWifi: 'WiFi 网络',
    typeContact: '联系人卡片',
    typeEmail: '电子邮件',
    typePhone: '电话号码',
    typeSms: '短信',
    typeLocation: '位置',
    blog: {
      tocTitle: '目录',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. 为什么使用二维码扫描器？',
          paragraphs: [
            '二维码扫描器本质上是一个移动设备相机，用于解码二维码中存储的信息。你只需将相机对准二维码；无论二维码方向如何，它都会读取特定图案、检测错误、在需要时纠错，并显示其中的信息。',
          ],
          listTitle: '二维码扫描器的类型：',
          bullets: [
            '基于网页的二维码扫描器：你可以使用浏览器支持的在线扫描器扫描二维码。你可以通过相机或上传图片来获取信息。若需自动跳转和更多高级功能，可访问 https://photremium.com。',
            '手机相机：一些现代手机在原生相机中内置了二维码扫描功能。只需对准二维码即可获取并解码信息。',
            '应用程序：有些应用专门用于扫描二维码。不过，若想要自动跳转及更多高级功能，你也可以通过此链接免费安装应用：https://photremium.com。',
            '硬件设备：也有专门用于扫描二维码的硬件设备。这些设备在大型商场中广泛用于商品结算。',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. 为什么选择我们的二维码扫描器？',
          paragraphs: [
            '你可以体验多种高级功能，包括跳转、复制二维码解码内容等。我们的二维码扫描器还提供许多其他实用功能，例如：',
          ],
          bullets: [
            '高速解码：我们的二维码扫描器解码速度非常快。你只需扫描二维码，工具就会立即显示信息，并提供复制文本/链接、检测到链接时直接打开、检测到联系人时自动保存等高级选项。',
            '无需安装：无需安装任何额外应用即可使用我们的二维码扫描器。你可直接在浏览器中免费使用。',
            '跨平台访问：可在任意设备上使用。无需担心系统版本或其他要求，支持范围广。',
            '全格式支持：二维码可存储的常见数据格式均可识别，包括纯文本、WiFi、URL、联系人、Gmail、Google Maps 等。',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. 分步指南：',
          steps: [
            {
              heading: '1. 首先，选择一种扫描二维码的方法。共有以下两种方式：',
              subSteps: [
                {
                  heading: 'i. 相机方式',
                  paragraphs: [
                    '你可以使用设备相机扫描二维码，即使你使用的是笔记本、台式机或任何支持普通相机的设备。点击“启动相机”按钮后会弹出权限请求，请允许本站使用相机进行二维码扫描。如果你误拒了权限，或没有出现权限请求，可按以下步骤手动开启相机权限：',
                  ],
                  notes: [
                    '➔ 对于 Chrome（Android / Desktop）：',
                    '1. 点击右上角三个点',
                    '2. 进入设置',
                    '3. （Android 可跳过）隐私和安全',
                    '4. 点击网站设置',
                    '5. 在权限部分点击相机',
                    '6. 找到我们网站的 URL： https://photremium.com/qr-code-scanner',
                    '7. 在下拉选项中将相机设置为允许。',
                    '➔ 对于 Safari（iPhone / iOS）：',
                    '1. 点击地址栏中的 AA 或网站设置图标。',
                    '2. 选择 Website Settings。',
                    '3. 点击 Camera 并选择 Allow。',
                    '4. 若仍被阻止：前往 iPhone 设置 > Safari > Camera，设为 Ask 或 Allow。',
                  ],
                },
                {
                  heading: 'ii. 相册方式',
                  paragraphs: [
                    '你可以上传二维码图片来获取其中的信息。点击“从相册扫描”按钮后会打开文件选择器，然后选择二维码图片。支持所有常见图片格式，如 .jpg、.jpeg、.png、.gif、.webp、.svg、.avif、.heic、.heif、.jxl、.bmp、.ico、.tiff、.tif、.jfif、.jpe、.pjpeg、.pjp、.apng、.svgz、.xbm 等。',
                  ],
                },
              ],
            },
            {
              heading: '2. 当你选择二维码后，所有信息都会显示；你可以复制、分享，若检测到链接还可直接打开。如有需要也可再次扫描。',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: '二维码扫描器的优势：.',
          paragraphs: [
            '二维码扫描器在数字化场景中有多种优势。它让支付、验证、信息访问都变得简单高效，即使离线模式也可使用。',
          ],
          bullets: [
            '信息即时可达：扫描二维码后可在毫秒级得到信息。它会快速解码图案、检测并修复错误，带来极快的使用体验。',
            '沟通更顺畅：在当下，银行信息、商品信息等小型数据也需要快速且安全地传递。二维码扫描器可有效解决这一问题，因为很多支付流程都通过扫码完成。此外，Google 在笔记本上创建新账号时也会通过二维码验证手机。',
            '电子票务：在汽车站、火车站或机场，你可以快速验票，无需长时间排队。机场中多点部署二维码扫描器也可减少拥堵，降低人力成本，节约运营预算。',
            '商品真伪验证：高端品牌常在商品上附加二维码。用户可扫码验证商品是否为正品。',
          ],
        },
      ],
    },
  },
  faceBlur: {
    seo: {
      uploadTitle: '人脸模糊工具 — 在线模糊图片中的人脸 | photremium.com',
      uploadDesc: '使用 AI 人脸检测自动模糊图片中的人脸。可选择模糊强度、形状和表情符号覆盖。100% 免费、快速、私密。',
      uploadKeywords: '人脸模糊, 遮盖人脸, 人脸检测, 隐私工具',
      workspaceTitle: '人脸模糊工具 — photremium.com',
      workspaceDesc: '自动模糊图片中的人脸。100% 免费、快速、私密。',
      workspaceKeywords: '人脸模糊',
    },
    title: '人脸模糊',
    desc: '自动检测并模糊图片中的人脸以保护隐私。可选择模糊强度、形状，或用有趣的表情符号遮盖人脸。100% 客户端——图片不离开您的设备。',
    toBlurFaces: '模糊人脸',
    autoDetection: '自动检测',
    autoDetectionDesc: 'AI 人脸检测功能即时识别所有人脸',
    customBlur: '自定义模糊',
    customBlurDesc: '调整模糊强度、形状和样式',
    private100: '100% 私密',
    private100Desc: '所有处理在浏览器中本地完成',
    blurTools: '模糊工具',
    faces: '人脸',
    faceDetection: '人脸检测',
    detecting: '检测中...',
    autoDetectFaces: '自动检测人脸',
    exitManualMode: '退出手动模式',
    manualSelect: '手动选择',
    nFaceRegions: '找到 {n} 个人脸区域',
    noFacesDetected: '未检测到人脸——请使用手动模式',
    manualHint: '在图片上点击并拖动以绘制矩形，选择要模糊的区域。',
    blurType: '模糊类型',
    blur: '模糊',
    emoji: '表情符号',
    blurIntensity: '模糊强度',
    strength: '强度',
    blurShape: '模糊形状',
    rectangle: '矩形',
    ellipse: '椭圆',
    circle: '圆形',
    chooseEmoji: '选择表情符号',
    blurRegionsN: '模糊区域 ({n})',
    faceN: '人脸 {n}',
    manualRegionN: '手动区域 {n}',
    manualN: '手动 {n}',
    clearAllRegions: '清除所有区域',
    processingDots: '处理中...',
    downloadBlurred: '下载模糊图片',
    downloadNImages: '下载 {n} 张图片',
    downloadDialogTitle: '并非所有图片都已编辑',
    downloadDialogText: '已编辑 {total} 张中的 {edited} 张。',
    downloadAll: '全部下载',
    removeRegion: '删除区域',
    region: '区域',
    notAllEdited: '并非所有图片都已编辑',
    editedXofY: '已编辑 {total} 张中的 {edited} 张。',
    nextImage: '下一张图片',
  },
  faqData: {
    imageConverter: [
      { q: '支持哪些图片格式转换？', a: '支持 JPG、PNG、WEBP、SVG、GIF、BMP、ICO 和 TIFF。可以在浏览器中即时在任何这些格式之间转换。' },
      { q: '转换会影响图片质量吗？', a: '对于 PNG 等无损格式不会。对于 JPG 或 WEBP 等有损格式，我们使用最优编码设置保持最高视觉质量。' },
      { q: '文件大小或数量有限制吗？', a: '没有限制。可以一次上传多张图片进行批量转换。所有处理在本地完成，速度取决于您的设备而非服务器。' },
      { q: '数据安全吗？图片会上传到服务器吗？', a: '完全安全。所有处理 100% 在浏览器中完成。图片不会离开您的设备，完全保证隐私。' },
      { q: '可以将透明 PNG 图片转换为 JPG 吗？', a: '可以。由于 JPG 不支持透明，转换时透明部分默认填充为白色背景。' },
    ],
    imageCompressor: [
      { q: '压缩图片会降低质量吗？', a: '不会，除非您把压缩比例调到超过建议范围，否则图片质量基本不会受影响。系统会通过指示颜色提示质量： i. 压缩 1% 到 40%：显示绿色提示“优质”。 ii. 压缩 41% 到 60%：显示黄色提示“普通质量”，该区间通常最推荐。 iii. 压缩 61% 到 100%：系统会显示红色“低质量”警告，在这个区间画质下降可能会比较明显。' },
      { q: '图片压缩支持哪些格式？', a: '我们的图片压缩工具支持以下全部格式：\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: '可以一次压缩多张图片吗？', a: '当然可以。只要设备性能允许，您可以一次压缩多张图片（甚至 100+）。由于压缩会占用本机资源，性能越高处理越快。若设备配置较低，也可以分批压缩；本工具免费使用，分多批处理也不受限。' },
      { q: '你们会把我的图片上传或存储到服务器吗？', a: '不会。我们不会上传或保存您的图片。所有压缩都在您的浏览器本地完成，图片不会离开您的设备，因此处理个人或私密图片也更安心。' },
      { q: '这个图片压缩工具是免费的吗？', a: '是的，我们的图片压缩工具永久免费。不会要求任何付款，也没有隐藏费用。包括多图批量压缩在内的所有功能都可免费使用。' },
    ],
    cropImage: [
      { q: '裁剪图片会降低质量吗？', a: '不会，裁剪图片完全不会影响图片的视觉质量。裁剪只是移除不需要的部分，不会改变被保留区域中的像素。因此，您可以在无像素损失的情况下，以原始质量裁剪图片。' },
      { q: '图片裁剪工具支持哪些图片格式？', a: '由于我们的图片裁剪工具支持几乎所有图片格式，您可以选择任意格式的图片。支持格式如下：\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: '我的图片会上传到你们的服务器吗？', a: '不会，所有处理都在您的本地浏览器中完成。您的图片不会上传到我们的服务器，因为图片不会离开您的设备。因此，您可以无风险地使用我们的图片裁剪工具处理私人图片。' },
      { q: '我可以一次裁剪多张图片吗？', a: '可以，如果您的系统支持，您可以一次裁剪多张图片（甚至 100+）。由于图片裁剪会占用系统资源，如果您使用高性能笔记本、电脑或手机，就可以一次处理大量图片。如果设备性能较低，您也可以分批裁剪；即使同时裁剪很多图片，本工具仍可免费使用。' },
      { q: '这个图片裁剪工具是免费的吗？', a: '是的，这个图片裁剪工具永久免费。您可以随时随地在任何设备上使用它。您不仅会获得适配所有设备的响应式体验，也永远不会被要求为任何高级功能付费。所有功能完全免费，无任何隐藏费用。' },
    ],
    resizeImage: [
      { q: '可以一次调整多张图片大小吗？', a: '当然可以。我们的工具支持同时调整多张图片。您可以上传设备可承受数量的图片，AI 引擎会并行处理。若设备性能较低，建议分批处理以避免卡顿。全部处理都在本地完成，不会上传服务器，隐私更安全。' },
      { q: '这个图片尺寸调整工具是免费的吗？', a: '是的，该工具永久免费。无需付费订阅也可使用高级功能。下载调整后的图片时同样没有任何隐藏费用。' },
      { q: '调整图片大小会损失质量吗？', a: '✅Decrease Size (downscale): 缩小图片通常不会降低视觉质量。很多情况下，缩小后的图片看起来甚至更清晰。因此缩小到更小尺寸一般不会造成画质损失。\n❌Increase Size (upscale): 将图片放大到超过原始尺寸可能会影响视觉质量。放大幅度越大，画质下降的可能性越高。' },
      { q: '这个工具安全吗？', a: '是的，我们的工具非常安全，尤其适合处理个人或敏感图片。所有处理均在您的设备本地完成，数据不会离开设备。您可以放心使用，不必担心隐私风险。' },
      { q: '支持哪些图片格式？', a: '我们的图片尺寸调整工具支持所有常见图片格式。可选择以下格式：\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: '背景去除是如何工作的？', a: '使用直接在浏览器中运行的先进 AI 模型检测主体，将其与背景分离，生成透明 PNG。' },
      { q: '对复杂背景有效吗？', a: '是的。AI 模型可以处理各种场景。主体和背景之间对比度越明显，效果越好。' },
      { q: '可以从多张图片中去除背景吗？', a: '可以。上传多张图片，它们将依次处理。可以将所有结果打包为 ZIP 或单独下载。' },
      { q: '输出格式是什么？', a: '始终输出具有透明背景的 PNG 文件。' },
      { q: '图片会发送到服务器吗？', a: '不会。AI 模型使用 WebAssembly 完全在浏览器中运行。图片始终保留在您的设备上。' },
    ],
    watermarkImage: [
      { q: '1. Photremium 的水印工具完全免费吗？', a: '是的，photremium.com/watermark-image 上的水印工具可免费使用，无需账号，也无需订阅。您可以给单张图片或整批图片添加水印，不会有付费墙、强制注册提示或下载限制。这个工具之所以免费，是因为让整个 Photremium 平台本身足够有价值，让用户愿意回来，而不是通过锁定单项功能来收费。' },
      { q: '2. 我一次可以给多少张图片加水印？', a: '该工具支持批量给多张图片同时加水印。您可以把整个图片文件夹直接拖放到上传区域，也可以在文件选择器里按住 Ctrl 单击，一次选择几十个文件。左侧缩略图栏会显示所有图片，点击“Watermark & Download All”后，工具会先按您的设置为每张图片渲染水印图层，再将它们打包成一个 ZIP 文件，或者按您的选择分别下载。实际批量大小主要受设备可用内存限制，而不是工具本身的人工上限。' },
      { q: '3. 支持哪些输入和输出图片格式？', a: '输入端接受浏览器 File API 能处理的所有图片格式，实际包括 JPEG、JPG、PNG、WEBP、GIF（静态）、BMP 和 SVG。输出格式会保持与原图一致：上传 PNG 就返回 PNG，上传 JPEG 就返回质量 0.95 的 JPEG。这种格式保留方式可以避免您不小心把无损 PNG 转成有损 JPEG。' },
      { q: '4. 不同分辨率的图片上，水印看起来会一样吗？', a: '会的，这要归功于工具的比例重定位引擎。当您批量处理不同尺寸的图片时，水印会先在参考图像上进行编辑，也就是您在画布里选中的那张图。导出时，系统会计算参考图像上每个水印图层的重心，把位置表示为相对于图像中心的比例偏移，再把同样的比例偏移应用到每张目标图片上。水印尺寸也会按比例缩放，并采用宽高两个缩放因子中较小的那个，确保它不会超出图片边界。这样一来，即使图片尺寸不同，水印的相对位置和大小也能保持一致。' },
      { q: '5. 我能用自己的 Logo 或签名代替文字水印吗？', a: '当然可以。右侧面板里的“Add Image”按钮可让您从设备上传任意图片作为水印图层。带透明背景的 PNG 效果最好，因为透明区域会保留，这样只显示 Logo 本身，不会出现白色或有色底框。您可以拖动角点缩放、旋转、翻转、调整不透明度，甚至添加边框或圆角。很多用户会专门保存一个透明背景版本的 Logo 用于水印。' },
      { q: '6. 怎样把水印调成透明或半透明？', a: '先在画布上点击水印图层将其选中。顶部出现的工具栏里有不透明度控制项，会显示百分比，您可以直接输入数值，也可以拖动滑块。若想要低调、专业且不抢图像主体的水印，30–50% 的不透明度通常最合适。若想要更明显、更醒目的版权提示，70–80% 效果不错。您也可以在图层管理器里通过“眼睛”图标切换图层可见性，快速对比有无水印的效果。' },
      { q: '7. 一张图里可以加多个水印吗？', a: '可以，图层系统支持无限数量的水印图层，而且每个图层都可以单独配置。您可以同时放一个右下角的文字版权声明、一个左上角的 Logo，以及一个铺满全图的 “SAMPLE” 平铺层。每个图层都有自己的不透明度、旋转、位置、尺寸和样式设置。右侧面板的图层管理器会帮您整理这些图层，并且您可以单独开启或关闭某个图层，而无需删除它们，这样在最终导出前就能轻松尝试不同组合。' },
      { q: '8. 平铺功能有什么作用，什么时候该用？', a: '平铺会把水印以网格模式重复铺满整张图片。Grid 2×2 会把四个副本按二乘二排列；Grid 3×3 会把九个副本按三乘三排列。tile spacing 控制项则可以调节各副本之间的间距。平铺最适合用于希望图片在未获授权前无法直接使用的场景。角落里的单个水印很容易被裁掉，而全覆盖的平铺图案会让图片在没有水印的情况下几乎无法使用。它常用于合同预览、给客户确认的草稿图，或任何在付款前不应被自由使用的内容。' },
      { q: '9. 这个工具能在手机和平板上使用吗？', a: '可以，工具完全响应式设计，专为移动端使用而优化。在宽度低于 900 像素的屏幕上，三栏布局会切换成堆叠式布局：缩略图条变成顶部可横向滚动的一行，画布占据主要区域，设置面板则变成底部抽屉，点击悬浮齿轮按钮时会滑上来。所有交互元素，包括图层拖动、缩放手柄和旋转，均支持触控，并使用 touchstart 和 touchmove 事件。移动端的缩放手柄也略大一些，尺寸为 16×16 像素，比桌面端更容易用手指准确点到。' },
      { q: '10. 我的图片数据私密吗？照片会上传到服务器吗？', a: '您的图片永远不会离开您的设备。整个水印流程，包括加载图片、渲染图层和导出最终文件，都是在浏览器里通过 JavaScript 和 HTML5 Canvas API 完成的。您上传图片时，File API 会在内存中创建该文件的表示；您添加水印图层时，它会被绘制到一个离屏 canvas 元素上；您下载结果时，canvas 的像素数据会被转换成 Blob 并交给浏览器下载，全程都在本地完成。不会有任何涉及您图片数据的网络请求。此外，工具还带有页面离开保护：如果图片已加载时您尝试关闭或跳转页面，浏览器会要求确认，以防止误删未完成的工作。' },
    ],
    qrCodeGenerator: [
      { q: '这个二维码会过期吗？', a: '不会，这些二维码不会过期，并且支持长期使用。由于它们以方块中的比特形式存储了硬编码指令，因此其中的信息无法被更改或删除。即使多年以后，您仍然可以通过任何相机扫描来访问其中的信息。' },
      { q: '为什么我的二维码无法扫描？', a: '您的二维码可能因以下原因无法扫描：i. 对比度过低：如果前景色和背景色过于相似，会影响二维码可见性并导致扫描失败。我们的工具在自定义时会提示低对比度或其他扫描相关问题。ii. 数据过多：如果二维码中包含的文本过长，二维码会变得非常复杂，扫描时会更困难。文本长度校验会在生成过程中提示最佳长度。iii. 打印模糊：请确保以高分辨率格式下载二维码，例如 PNG 或 SVG，这些格式都已被我们的工具支持。' },
      { q: '我可以在二维码里添加 Logo 吗？', a: '当然可以。您可以上传自定义 Logo，或从内置 Logo 库中选择一个用于二维码。所选 Logo 会自动调整并放置在二维码中心位置。' },
      { q: '我该如何扫描二维码？', a: '您可以使用手机摄像头扫描二维码。若需要自动跳转链接以及更多高级功能，您也可以免费使用我们的二维码扫描器：https://photremium.com/qr-code-scanner。' },
      { q: '我可以免费生成多少个二维码？', a: '无限制！您可以免费生成多个二维码。所有功能、自定义选项和模板都永久免费，无需订阅即可使用高级功能。' },
      { q: '生成二维码需要登录/注册吗？', a: '不需要。只需输入文本，生成二维码，并在自定义后下载即可。无需登录或注册，所有功能均可完全免费使用。' },
    ],
    qrCodeScanner: [
      { q: '我可以从已保存图片和截图中扫描二维码吗？', a: '**可以**，你可以从已保存图片或截图中扫描二维码。我们的二维码扫描器 https://photremium.com/qr-code-scanner 支持从相册扫描二维码。你只需选择图片，即可获得该二维码解析出的全部信息。' },
      { q: '使用二维码扫描器需要安装 App 吗？', a: '**不需要**，我们的网页二维码扫描器无需安装任何应用即可使用。你可以在任何设备上免费使用我们的高级二维码扫描功能。' },
      { q: '为什么扫描器无法识别二维码？', a: '二维码无法识别可能由以下原因造成：i. 光线不足：在昏暗环境下扫描会更困难。若从屏幕扫描，请开启闪光灯并提高亮度。ii. 距离不当：距离过近或过远也会影响识别。建议扫描距离约为 10 英寸（25cm）。iii. 相机镜头脏污：镜头脏会导致识别失败。请在扫描前清洁镜头。『你看到扫描框网格了吗？将二维码放入框内即可更容易扫描成功。』' },
      { q: '这个工具可以扫描反色或彩色二维码吗？', a: '**可以**，你可以扫描任意颜色或任意方向的二维码。但如果前景色与背景色对比度过低，可能会增加扫描难度。' },
      { q: '这个工具免费吗？', a: '**是的**，此工具完全免费。你可以永久免费、无限次扫描二维码。' },
    ],
    faceBlur: [
      { q: '人脸检测是如何工作的？', a: '使用直接在浏览器中运行的 AI 驱动人脸检测模型。它识别图片中的人脸，以便您可以对其应用模糊效果。' },
      { q: '可以选择要模糊哪些人脸吗？', a: '可以。检测后，每个人脸区域都会被高亮显示，您可以选择要模糊的区域并分别调整每个区域的模糊强度。' },
      { q: '有哪些模糊样式可用？', a: '可以选择高斯模糊、像素化或纯色覆盖。每种效果的强度都完全可调。' },
      { q: '可以一次模糊多张图片中的人脸吗？', a: '可以。上传多张图片，设置模糊区域，然后将所有已处理图片打包为 ZIP 或单独下载。' },
      { q: '照片会被发送到远程服务器吗？', a: '不会。AI 模型使用 WebAssembly 在浏览器中运行。照片不会上传到任何服务器。' },
    ],
    photoEditor: [
      { q: '有哪些编辑功能？', a: '调整亮度、对比度、饱和度，应用滤镜，添加文字覆盖、相框和贴纸——全部在浏览器中完成。' },
      { q: '支持撤销/重做吗？', a: '支持。有完整的撤销/重做历史记录，您可以自由实验而不会丢失工作。' },
      { q: '可以编辑和导出哪些文件格式？', a: '可以编辑常见格式，包括 JPG、PNG 和 WEBP。可以以您喜欢的格式和质量导出。' },
      { q: '编辑器可以在移动设备上使用吗？', a: '可以。完全响应式且支持触摸，可以在智能手机和平板电脑上编辑图片。' },
      { q: '图片会保存到服务器吗？', a: '不会。所有编辑都在本地执行。图片不会离开您的设备。' },
    ],
  },
};

export default zh;